<template>
  <div style="width: 100%; padding-bottom: 4.33333rem; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto; height: 100vh; overflow-y: auto;">
    <div>
      <van-nav-bar left-arrow @click-left="onClickLeft">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" />
        </template>
      </van-nav-bar>
    </div>

    <!-- 渐变色背景和头像区域（完全保留原样） -->
    <div style="background: linear-gradient(90deg, #fc78af, #f22678); height: 90px; border-radius: 0px 0px 20px 20px"></div>
    <div style="width: 100%; margin-top: -80px">
      <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 90%; margin: 4% auto 0;">
        <div style="border-radius: 10px; overflow: hidden; width: 120px; height: 120px;">
          <img :src="data.one" style="object-fit: cover; width: 120px; height: 120px;">
        </div>
        <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: column; padding-left: 1rem; flex: 1;">
          <p style="color: #fff; font-size: 1.06667rem;">
            {{ data.xuanfei_name }}
            <span style="margin-left: 10px; color: rgb(250, 154, 10); font-size: 13px; font-weight: 600;">{{ data.id }}</span>
          </p>
          <div style="height: 28px; margin-top: 4px;">
            <img src="/img/home/rz.71425b8f.png" style="width: 62px; height: 28px" alt="">
          </div>
          <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; margin-top: 2px;">
            <p style="font-size: .8rem; color: #fc4f2c; font-weight: 600;">{{ $t("foorter.top8") }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- feiziInfo 模块 -->
    <div class="feiziInfo" style="background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
      <div class="topInfo">
        <!-- 标题和小图轮播（完全保留原样） -->
        <div><span>{{ $t("foorter.top11") }}</span></div>
        <div class="imgswiper">
          <div v-for="(i, index) in data.img_url" :key="index" style="width: 178px; height: 184px; margin-right: 10px;">
            <div style="width: 178px; height: 184px;">
              <img :src="i" class="van-image__img" style="object-fit: cover;" @click="imgShow(i)" />
            </div>
          </div>
        </div>
        
        <div class="dark-card score-address-card">
          <div class="score-left">
            <div class="score-label">{{$t("foorter.top20")}}</div>
            <div class="score-number">10.0</div>
            <div class="beauty-label"></div>
          </div>
          <div class="address-right">
            <div class="info-item">
              <div class="item-label">{{$t("auth.top16")}}:</div>
              <div class="item-value">{{$t("auth.top18")}}</div>
            </div>
            <div class="info-item">
              <div class="item-label">{{$t("auth.top17")}}:</div>
              <div class="item-value">{{$t("auth.top18")}}</div>
            </div>
          </div>
        </div>

        <!-- 下方卡片：详情列表（Stage name / Location / Introduction） -->
        <div class="dark-card info-detail-card">
          <div class="detail-row">
            <span class="icon"></span>
            <span class="label">ID:</span>
            <span class="value">{{ data.xuanfei_name }}</span>
          </div>
<div class="detail-row">
<span class="icon"></span>
<span class="label">{{$t("index.height")}}:</span>
<span class="value">{{ data.hight }}cm</span>
</div>
          <div class="detail-row">
            <span class="icon"></span>
            <span class="label">{{$t("foorter.top9")}}:</span>
            <span class="value"> <van-rate v-model="data.number" readonly    color="#ffd21e" size="18px" /></span>
          </div>
          <div class="detail-row">
            <span class="icon"></span>
            <span class="label">{{$t("index.residence")}}:</span>
            <span class="value">{{ data.class_name }}</span>
          </div>
        </div>
<div class="dark-card info-detail-card">
	{{$t("foorter.top13")}}
<div class="detail-row">
<span class="label" style="font-size: 14px;color: #fff">{{$t("foorter.top14")}}</span>
</div>
</div>

        <!-- 原有的 flagArray 等隐藏元素，全部保留 -->
        <div style="width: 100%; display: none;">
          <div class="item" v-for="(item, index) in data.flagArray" :key="index">{{ item }}</div>
        </div>
        <!-- 原有的点赞、预约等隐藏模块，全部保留 -->
        <div class="yuyueBox" @click="getUserGameList" style="display: none;">{{ $t("index.instant_booking") }}</div>
        <div class="dianzanimg" @click="clickPraise" style="display: none;">
          <div class="van-image" style="width: 60px; height: 60px;">
            <img src="/img/zan.c28032c8.png" class="van-image__img" style="object-fit: cover;" />
          </div>
          <p style="color: rgb(107, 34, 179); margin: 0px;">{{ data.dianzan }}</p>
        </div>

      </div>
    </div>

    <!-- 底部固定按钮（保留原样） -->
    <div style="background: linear-gradient(90deg, #fc78af, #f22678); position: fixed; bottom: 10px; color: #fff; width: 70%; height: 32px; border-radius: 10px; margin-left: 15%; font-size: 16px; line-height: 32px; text-align: center;" @click="toServicePage()">
      {{ $t("foorter.top15") }}
    </div>
  </div>
</template>

<script>
import videojs from 'video.js';
export default {
  data() {
    return {
      showMsg: false,
      data: {},
      currentIndex: 0,
      currentImage: '',
      isPraised: false,
      player: null,
      kefu: '',
    };
  },
  methods: {
    getxuanfeidata() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: { id: this.$route.query.id }
      }).then(res => {
        this.data = res.data;
        const lanng = this.$t("auth.lang");
        const parts = this.data.flag.split('|');
        lanng == 'zh' ? this.data.flag = parts[0] : lanng == 'en' ? this.data.flag = parts[1] : lanng == 'ja' ? this.data.flag = parts[2] : this.data.flag = parts[3];
        this.data.flagArray = this.data.flag.split('，');
        this.currentImage = this.data.img_url[0];
        console.log(this.data, 998);
      });
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.kefu = res.data.kefu;
      });
    },
    onClick(name) {
      console.log(name);
      if (name === 'phone') {
        this.showMsg = false;
        if (this.player) {
          this.player.pause();
        }
      } else {
        this.showMsg = true;
      }
    },
    onClickImg(index) {
      this.currentIndex = index;
      this.currentImage = this.data.img_url[index];
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    clickPraise() {
      if (this.isPraised) {
        this.data.dianzan--;
        this.isPraised = false;
      } else {
        this.data.dianzan++;
        this.isPraised = true;
      }
    },
    imgShow(index) {
      const image = new Image();
      image.src = index;
      image.onload = () => {
        const previewContatiner = document.createElement('div');
        previewContatiner.style.position = 'fixed';
        previewContatiner.style.top = 0;
        previewContatiner.style.bottom = 0;
        previewContatiner.style.left = 0;
        previewContatiner.style.right = 0;
        previewContatiner.style.zIndex = 9999;
        previewContatiner.style.backgroundColor = 'rgba(0,0,0,0.8)';
        previewContatiner.style.display = 'flex';
        previewContatiner.style.justifyContent = 'center';
        previewContatiner.style.alignItems = 'center';
        document.body.appendChild(previewContatiner);
        
        const previewImage = document.createElement('img');
        previewImage.src = index;
        previewImage.style.maxWidth = '80%';
        previewImage.style.maxHeight = '80%';
        previewImage.style.zIndex = 9999;
        previewContatiner.appendChild(previewImage);
        
        previewContatiner.addEventListener('click', () => {
          document.body.removeChild(previewContatiner);
        });
      };
      image.onerror = function () {
        console.log('图片加载失败');
      };
    },
    toServicePage() {
      console.log(this.kefu);
      window.location.href = this.kefu;
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.$toast('먼저 활성화 작업을 완료하십시오.');
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    this.getxuanfeidata();
    this.getBasicConfig();
  },
  mounted() {
    this.player = videojs('my-video');
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: linear-gradient(90deg, #fc78af, #f22678);
  height: 44px;
}
.van-nav-bar .van-icon {
  color: #fff !important;
}
.feiziInfo {
  background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;
}
.topInfo {
  position: relative;
  padding: 4vw 40px;
  background: #fff;
}
.feiziInfo .topInfo div:first-child span:first-child {
  color: #2c1868;
  font-size: 5vw;
}
.topInfo .item {
  background: linear-gradient(50deg, #9b54ca, #e6557f);
  color: #fff;
  display: inline-block;
  border-radius: 20px;
  margin-right: 30px;
  font-size: 24px;
  padding: 16px;
  margin-bottom: 30px;
}
.yuyueBox {
  position: absolute;
  right: 4vw;
  bottom: 40px;
  color: #fff;
  padding: 20px 30px;
  background: linear-gradient(20deg, #e73266, #ee5380);
  border-radius: 7vw;
}
.dianzanimg {
  position: absolute;
  top: 4vw;
  right: 7vw;
  text-align: center;
}
.cenInfo {
  padding: 4vw 20px;
  background: #fff;
}
.imgswiper {
  width: 100%;
  overflow-x: scroll;
  margin: 4vw 0;
  display: flex;
  flex-wrap: nowrap;
}
.imgswiper .active {
  border: 10px solid #e54878;
}
.btmInfo {
  padding: 4vw 40px;
  background: #fff;
}
::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}
.video-js {
  width: 100%;
  height: 336px;
  font-size: 24px;
}

/* ===== 深色个人档案卡片 (替换原白色内容区域) ===== */

.dark-card {
  background: linear-gradient(90deg, rgb(252, 120, 175), rgb(242, 38, 120));
  border-radius: 12PX;
  padding: 16PX 20PX;
  margin-bottom: 16PX;
  color: #fff;
}

/* 上方卡片：评分 + 地址/联系方式 */
.score-address-card {
  display: flex;
}
.score-left {
  flex: 0 0 35%;
  border-right: 1PX solid #444;
  padding-right: 16PX;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.score-label {
  font-size: 12PX;
  color: #fff;
  font-weight: 500;
  margin-bottom: 2PX;
}
.score-number {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}
.beauty-label {
  font-size: 12PX;
  color: #fff;
  font-weight: 600;
  margin-top: 2PX;
}
.address-right {
  flex: 1;
  padding-left: 16PX;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8PX;
}
.info-item {
  font-size: 11PX;
  line-height: 1.4;
}
.item-label {
  color: #fff;
  font-weight: 600;
  margin-bottom: 2PX;
}
.item-value {
  color: #fff;
  font-weight: 400;
}

/* 下方卡片：详情列表 */
.info-detail-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.detail-row {
  display: flex;
  align-items: center;
  gap: 10PX;
  font-size: 14PX;
  color: #fff;
}
.detail-row .icon {
  font-size: 16PX;
  color: #fff;
  width: 20PX;
  text-align: center;
}
.detail-row .label {
  color: #fff;
  font-weight: 500;
}
.detail-row .value {
  color: #fff;
  font-weight: 400;
}
</style>